<template>
  <fragment v-if="partnerList.length">
    <button
      id="admin-partner"
      type="button"
      :class="[dark ? 'dark' : '']"
      @click="toggleRightSidebar"
    >
      <span class="sac__font-18">{{ corp }}</span>
      <span class="icon-luc-SlidersHorizontal sac__font-24 f-white" />
    </button>
    <AdminFilter
      :getData="action"
    />
  </fragment>
</template>
<script>
import AdminFilter from '@shared/components/admin/AdminFilter.vue';
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'SelectedPartner',
  components: { AdminFilter },
  mixins: [adminMixin],
  props: {
    action: Function,
    dark: Boolean,
  },
  computed: {
    corp() {
      if (!this.adminFilter.corpName) {
        return '';
      }
      return this.adminFilter.corpName.length > 28 ? `${this.adminFilter.corpName.substring(0, 28)}...` : this.adminFilter.corpName;
    },
  },
  mounted() {
    this.$store.dispatch('getAdminPSMList');
  },
  methods: {
    toggleRightSidebar() {
      this.$store.dispatch('changeAdminValues', [{
        field: 'showRightSidebar',
        value: true,
      }]);
    },
  },
};
</script>

<style scoped lang="scss">
#admin-partner {
  border-radius: 4px;
  display: grid;
  grid-auto-flow: column;
  gap: 16px;
  padding: 0 12px;
  align-items: center;
  text-align: center;
  color: $WHITE;
  font-weight: 500;
  height: 42px;
  min-width: 200px;
  background-color: $NBLUE110;
  &.dark {
     background-color: $N95;
  }
}
</style>
